// extracted by mini-css-extract-plugin
module.exports = {"DialogPaper":"Dialogs_DialogPaper__3P0jl","DialogContentWrapper":"Dialogs_DialogContentWrapper__1PQTm","DialogContentTitle":"Dialogs_DialogContentTitle__3frin"};